<table>
    <thead>
        <tr>
            <th>{{'gestionLicencias.parametros.table.tabs.grupoEtiquetasDeno.caja' | translate}}</th>
            <th>{{'gestionLicencias.parametros.table.tabs.grupoEtiquetasDeno.pallet' | translate}}</th>
            <th class="actions">{{'gestionLicencias.parametros.table.tabs.grupoEtiquetasDeno.acciones' | translate}}</th>
        </tr>
    </thead>
    <tbody>
        <app-new-edit-param-grupo-etiquetas-deno class="component-in-row" [editable]="editable" [grupoEtiquetasCaja]="grupoEtiquetasCaja" [denominacionId]="denominacionId" [almacenId]="almacenId"
        [licenciaSwId]="licenciaSwId" [grupoEtiquetasPallet]="grupoEtiquetasPallet" (refresh)="toRefresh($event)" (editableChanged)="editableChanged($event)"
        (pushMessage)="pushMessage.emit($event)"></app-new-edit-param-grupo-etiquetas-deno> 
    </tbody>
    <tfoot *ngIf="(!grupoEtiquetasCaja || grupoEtiquetasCaja.length < 1) || (!grupoEtiquetasPallet || grupoEtiquetasPallet.length < 1) ">
        <tr>
            <td colspan="6">
                {{ 'global.noContent' | translate }}
            </td>
        </tr>
    </tfoot>
</table>